import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke041aRequest, Sgke041aResponse, Sgke041aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke041aService {

  /**
   * コンストラクタ
   * @param {Sgke041aService} sgke041aService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke041aService
   */
  constructor(private sgke041aService: Sgke041aService
    , private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 請求お客様情報検索API呼び出し
   *
   * @param {*} request
   * @memberof UsedSgke041aService
   */
  doSgke041a(request: Sgke041aRequest): Observable<Sgke041aResponse> {

    return this.sgke041aService.ke10RSGKE041APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE041A');
          return throwError(err.message);
        }
        )
      );
  }
}
